import { render, staticRenderFns } from "./pangle-site.vue?vue&type=template&id=46145aa6&"
import script from "./pangle-site.vue?vue&type=script&lang=js&"
export * from "./pangle-site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports